import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import { DefinitionBlock, Heading, NotationBlock } from '../../util/typography';
import { Body } from '../../util/typography/Text';
import { StaticImage } from 'gatsby-plugin-image';
import TieredCTAGrid from '../TieredCTAGrid';
import AccordionDrawer from '../layout/AccordionGroup/AccordionDrawer';
import TriageList from '../TriageList';
import CustomHomePageNccnAccordion from './CustomHomepageNccnAccordion';
import { CustomTumorNCCN } from './data/CustomHomepageNccnData';
import {indications} from '../../util/data/indications';
import TieredCTACard from '../TieredCTAGrid/TieredCTACard';
import { createMarkup } from '../../util/functions';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';
import { between } from 'polished';
import qlexTrilogy from '../../assets/QLEX-trilogy.png'; 
import qlexTrilogyDesk from '../../assets/QLEX-trilogy-desktop.png';
import AnchorLinks, { AnchorLink } from '../AnchorLinks';

const bp= NAVIGATION_BREAKPOINT;

const Wrapper = styled.div`
display: flex;
padding: 40px;
padding-right: 60px;
background: ${colors.baseGreen};
border: 4px solid ${colors.keytrudaGreen};
border-radius: 8px;
color: ${colors.ink};
overflow: auto;
z-index:0;

//will add transition here later

background-image: url(${qlexTrilogyDesk});
background-repeat: no-repeat;
background-position: bottom right;
background-size: contain;
transition: border 0.3s ease-in-out;

// &:hover {
//     box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.35);
//     // border: none;
//     border: 1px transparent;
// }

@media(max-width: 1024px) and (min-width: 997px){
background-position:bottom right -30px;
}

@media(max-width: 997px) and (min-width: ${bp}){
background-position:bottom right -40px;
}

@media(max-width: ${bp}){
padding: 30px 20px;
background-image: none;
}
`;

const BodyContent = styled(Heading.H3)`
margin-bottom: 16px;
strong {
    font-weight: 600;
}

@media (max-width: ${bp}){
margin-bottom: 12px;
}
`;

const CustomHeader = styled(Heading.H6)`
text-transform: uppercase;
padding-bottom: 10px;
//margin-bottom: 10px;
//max-width: 440px;
min-width: 200px;
font-weight: 700;

// border-bottom: 2px solid ${colors.lightPurple};

@media (max-width: ${bp}){
padding-bottom: 8px;
margin-bottom: 8px;
}

`;

const SubBodyContent = styled(Heading.H5)`
padding: 10px;
margin-top: 16px;
background: ${colors.keytrudaGreenBackground};
border: 1px solid ${colors.pebble};
border-radius: 8px;

@media(max-width: ${bp}){
margin-top: 10px;
}
`;

const cards = {}

const customTumorGridRow = {
    default: [
        {
            type: '100',
            items: [{
                title: 'Interactive Prescribing Information',
                url: '/prescribing-information/',
                target: '_blank',
                buttonLabel: 'View Prescribing Information',
                verticalCenter: 'center'
            }]
        }
    ]
};

const tumorNccnAccordion = {
    'bre': {
        title: 'Select NCCN Guidelines®',
        subtitle: 'For Triple-Negative Breast Cancer (TNBC)',
        indications: [
            27,
            26,
            39
        ],
    }
}

const HeroWrapper = styled.div`
 max-width: 764px;
`;

const TriageWrapper = styled.div`
scroll-margin-top: 50px;
[class*=ComponentWrapper] {
    margin-bottom: 20px;
}
`;

const AccordionWrapper = styled.div`
 scroll-margin-top: 50px;
 margin-bottom: 20px;
`;

const DefinitionBlockWrapper= styled.div`
strong {
color: ${colors.charcoal};
}

`;

const AnchorLinkWrapper=styled.div`
max-width: ${({maxwidth})=>  maxwidth ? maxwidth+'px' : '100%'};
margin-bottom: ${({mb}) => between( mb ? `${mb}px` : '12px', '16px', '320px', '1440px')};

[class*="AnchorLink__AnchorArrowContainer"]{
height: 22px;
}
`;

const customHomepageHeroContent = {
    'bre': {
        cancerID:19,
        header: 'When Given as Part of a COMPLETE Treatment Regimen',
        tnbcAccordion: 'See All Triple-Negative Breast Cancer (TNBC) Indications',
        tnbcNccn:'View Select NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®)',
        body: `Pembrolizumab (KEYTRUDA) is the First and Only Anti–PD-1 IO Agent With <strong>NCCN Category 1 Preferred Recommendations in 3 Indications</strong> Across Both High-Risk Early-Stage TNBC and PD-L1–Positive Unresectable Locally Advanced/Recurrent or Metastatic TNBC (CPS ≥10)<sup>1</sup>`,
        definitions: '<strong>CPS = combined positive score; IO = immunotherapy; NCCN = National Comprehensive Cancer Network; PD-1 = programmed death receptor-1; PD-L1 = programmed death ligand 1.</strong>'
    }
}

export const CustomTumorHomepage = props => {
    const [isOpen, setOpen] = useState(false);
    const [isClient, setClient] = useState(false);
    const [tumorOpen, setTumorOpen] = useState(false);

    const [accordionData, setAccordionData] = useState(() => {
        if (props.group) {
            return tumorNccnAccordion[props.group];
        }
        else return '';
    })

    useEffect(() => {
        setClient(true)
    }, [])

    function clickHandler() {
        setOpen(!isOpen);  
    }

    function handlTumor() {
        setTumorOpen(prev=> false);
    }

    const TumorNccContentCard = {
        'bre': {
            anchorlink: [{label: 'NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®)'}],
            tumors:[{ header: 'High-Risk Early-Stage TNBC', text: 'KEYTRUDA and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Injection 165 mg + 2,000 units/mL are each indicated for the treatment of adult patients with high-risk early-stage triple-negative breast cancer (TNBC) in combination with chemotherapy as neoadjuvant treatment, and then each continued as a single agent as adjuvant treatment after surgery.'},
                {header: 'Advanced TNBC', text: `<p>KEYTRUDA and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Injection 165 mg + 2,000 units/mL are each indicated, in combination with sacituzumab govitecan-hziy, for the first-line treatment of adult patients with unresectable locally advanced or metastatic triple-negative breast cancer (TNBC) whose tumors express PD-L1 (CPS ≥10) as determined by an FDA-authorized test.</p><p>KEYTRUDA and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Injection 165 mg + 2,000 units/mL are each indicated, in combination with chemotherapy, for the treatment of adult patients with locally recurrent unresectable or metastatic triple-negative breast cancer (TNBC) whose tumors express PD-L1 (CPS ≥10) as determined by an FDA-authorized test.</p>`}
            ],
            nccn: {
                data:
                    {bodyCopy :`<h6>Pembrolizumab and berahyaluronidase alfa-pmph subcutaneous injection may be substituted for IV pembrolizumab. Pembrolizumab and berahyaluronidase alfa-pmph has different dosing and administration instructions compared to IV pembrolizumab.<sup>1</sup></h6>` },
                definitions: `<p>Category 1 = Based upon high-level evidence (≥1 randomized phase 3 trials or high-quality, robust meta- analyses), there is uniform NCCN consensus (≥85% support of the Panel) that the intervention is appropriate.<sup>1</sup></p>
                <p>According to National Comprehensive Cancer Network® (NCCN®), preferred intervention = intervention that is based on superior efficacy, safety, and evidence; and, when appropriate, affordability.<sup>1</sup></p>
                <p>NCCN makes no warranties of any kind whatsoever regarding their content, use or application and disclaims any responsibility for their application or use in any way.</p>
                <p>CPS = combined positive score; PD-1 = programmed death receptor-1.</p>`,
                references:[ {label: '1.', text: 'Referenced with permission from the NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®) for Breast Cancer V.2.2026. © National Comprehensive Cancer Network, Inc. 2026. All rights reserved. Accessed March 2, 2026. To view the most recent and complete version of the guideline, go online to NCCN.org.'}]
            }
        }
    }
    const items = [{label: 'NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®)'}];

    return (
        <>
            {isClient && props.group &&
                <div>
                    <HomepageHero heroContent={customHomepageHeroContent[props.group]} setOpen={setOpen} setTumorOpen={setTumorOpen} />
                    <TieredCTACard tumors={TumorNccContentCard[props.group].tumors} data= {TumorNccContentCard[props.group]} setOpen={setOpen} />
                       {/* nccn accordion */}
                    <AccordionWrapper id='view-select-nccn-clinical-practice-guidelines-in-oncology-nccn-guidelines'>
                        <AccordionDrawer
                            isOpen={isOpen}
                            title={accordionData.title}
                            subtitle={accordionData.subtitle}
                            clickHandler={() => clickHandler()}
                        > 
                            { 
                                accordionData.indications.map((item, id) => {
                                    return (
                                        <CustomHomePageNccnAccordion 
                                            body={CustomTumorNCCN[item].data}
                                            footnotes={CustomTumorNCCN[item].footnotes}
                                            definitions= {CustomTumorNCCN[item].definitions}
                                            references={CustomTumorNCCN[item].references}
                                            title={CustomTumorNCCN[item].title}
                                        />
                                    )
                                })
                            }                       
                        </AccordionDrawer>
                    </AccordionWrapper> 
                            {/* TNBC accordion */}
                    <TriageWrapper id="see-all-triple-negative-breast-cancer-tnbc-indications">
                        <TriageList listType="efficacy" tumor={props.group} homepage handlTumor={handlTumor} tumorOpen={tumorOpen}  />
                    </TriageWrapper>                
                </div>
            }
        </>
    )
}

const HomepageHero = props => {
    return (
        <Wrapper>
            <HeroWrapper>
                <AnchorLinkWrapper onClick={()=>props.setTumorOpen(true)} mb={10}>
                    <AnchorLink label={props.heroContent.tnbcAccordion} />
                </AnchorLinkWrapper>
                
                <CustomHeader as='H5' dangerouslySetInnerHTML={createMarkup(props.heroContent.header)} />
                <BodyContent dangerouslySetInnerHTML={createMarkup(props.heroContent.body)} />
                <AnchorLinkWrapper  maxwidth='400' onClick={()=>props.setOpen(true)}>
                    <AnchorLink label={props.heroContent.tnbcNccn} />
                </AnchorLinkWrapper>
                
                {(props.heroContent.definitions) && 
                    <DefinitionBlockWrapper>
                        <DefinitionBlock text={props.heroContent.definitions} />
                    </DefinitionBlockWrapper>                   
                }
            </HeroWrapper>
        </Wrapper>
    )
}

export default HomepageHero;